import {Component, OnDestroy, OnInit} from "@angular/core";
import {UtilsService} from "../core/utils/utils.service";
import {Auth2Service} from "../core/services/security/auth2.service";
import {Subscription} from "rxjs";
import {ChangelogDto} from "../core/dtos/changelog/changelog-dto";
import {ChangelogService} from "../core/services/changelog/changelog.service";
import {VersionDto} from "../core/dtos/changelog/version-dto";

@Component({
    templateUrl: './changelogs.component.html',
    styleUrls: ['./changelogs.component.scss'],
    standalone: false
})
export class ChangelogsComponent implements OnInit, OnDestroy {

  logged: boolean = false;

  changelog: ChangelogDto;
  versionToDisplay: VersionDto;

  subLog: Subscription;
  subChangelog: Subscription;

  constructor(public utils: UtilsService, private auth2Svc: Auth2Service, private changelogSvc: ChangelogService) {
  }

  ngOnInit(): void {
    this.initLoggedSubscription();
    this.initChangelogSubscription();
  }

  ngOnDestroy(): void {
    this.utils.unsubscribe(this.subLog);
    this.utils.unsubscribe(this.subChangelog);
  }

  handleVersionSelection(version: VersionDto): void {
    this.versionToDisplay = version;
  }

  initLoggedSubscription = (): void => {
    this.subLog = this.auth2Svc.isLoggedIn$
      .subscribe(res => this.logged = res);
  }

  initChangelogSubscription = (): void => {
    this.subChangelog = this.changelogSvc.fetchChangeLog().subscribe((res) => {
      res.one.versions = this.reverseVersionsOrder(res.one.versions);
      this.versionToDisplay = this.findLatestVersion(res.one.versions, res.one.latestVersion);
      return this.changelog = res.one
    });
  }

  findLatestVersion(versions: VersionDto[], latest: string): VersionDto | null {
    for (let version of versions) {
      if (version.number === latest) {
        return version;
      }
      const found: VersionDto = this.findLatestVersion(version.subVersions, latest);
      if (found) {
        return found;
      }
    }

    return null;
  }

  reverseVersionsOrder(versions: VersionDto[]): VersionDto[] {
    versions.reverse();
    versions.forEach((v: VersionDto): void => {
      v.subVersions.reverse();
      v.subVersions.forEach((v: VersionDto) => v.evolutions.reverse());
    });

    return versions;
  }
}
